import { makeAutoObservable } from "mobx";
import {
  deletePosition,
  getAllPosition,
  getPositionByCode,
  getPositionById,
  pagingPosition,
  savePosition,
} from "app/services/PositionService";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { Profession } from "app/common/Model/Profession";
import { checkSearchObject } from "app/common/LocalFunction";
import {
  downloadTemplatePosition,
  importExcelPosition,
} from "app/services/ImportExcelService";

export default class PositionStore {
  listAllPosition = [];
  searchPosition = new SearchObject();
  pagePosition = null;
  selectedPosition = null;
  openFormCreateOrEdit = false;
  openConfirmDeletePosition = false;
  recentlyUpdated = false;
  selectedRowPosition = null;
  constructor() {
    makeAutoObservable(this);
  }

  setSelectedRowPosition = (row) => {
    this.selectedRowPosition = row;
  };

  checkPositionCode = async (code) => {
    if (code != null) {
      return await getPositionByCode(code.trim()).then((position) => {
        if (position != null) {
          toast.error("Mã chức danh đã tồn tại, vui lòng nhập mã chức danh khác");
        }
      });
    }
  };

  getAllPosition = async () => {
    if (this.listAllPosition?.length === 0 || this.recentlyUpdated) {
      getAllPosition()
        .then(({ data }) => {
          this.listAllPosition = data;
          this.recentlyUpdated = false;
        })
        .catch((error) => {
          console.error(error);
          toast.error("Lấy dữ liệu chức danh có lỗi");
        });
    }
  };

  pagingPosition = () => {
    pagingPosition(this.searchPosition)
      .then(({ data }) => {
        this.pagePosition = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu chức danh có lỗi");
      });
  };

  handleChangeFormSearch = (searchPosition) => {
    this.searchPosition = checkSearchObject(
      this.searchPosition,
      searchPosition
    );
    this.pagingPosition();
  };

  handleOpenFormCreateOrEdit = (positionId) => {
    if (Boolean(positionId)) {
      getPositionById(positionId).then(({ data }) => {
        this.selectedPosition = data;
        this.openFormCreateOrEdit = true;
      });
    } else {
      this.selectedPosition = new Profession();
      this.openFormCreateOrEdit = true;
    }
  };

  savePosition = async (position, { setSubmitting }) => {
    return await savePosition(position)
      .then(() => {
        this.selectedPosition = null;
        toast.success("Lưu chức danh thành công!");
        this.handleClosePopup();
        this.pagingPosition();
        this.recentlyUpdated = true;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu chức danh có lỗi");
      })
      .finally(() => setSubmitting(false));
  };

  handleDeletePosition = (position) => {
    this.selectedPosition = { id: position?.id };
    this.openConfirmDeletePosition = true;
  };

  handleConfirmDeletePosition = async () => {
    return await deletePosition(this.selectedPosition?.id)
      .then(() => {
        if (
          this.searchPosition?.pageIndex > 1 &&
          this.pagePosition?.content?.length === 1
        ) {
          this.searchPosition.pageIndex -= 1;
        }
        toast.success("Xóa chức danh thành công!");
        this.handleClosePopup();
        this.pagingPosition();
        this.recentlyUpdated = true;
      })
      .catch((err) => {
        console.error(err);
        toast.error("Xóa chức danh có lỗi");
      });
  };

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDeletePosition = false;
  };

  handleDownloadExcelTemplate = async () => {
    try {
      const response = await downloadTemplatePosition();

      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "VI_TRI.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error downloading template:", error);
    }
  };

  importExcel = (file) => {
    importExcelPosition(file)
      .then(() => {
        toast.success("Nhập excel thành công");
        this.searchPosition = {
          ...this.searchPosition,
          pageIndex: 1,
        };
        this.pagingPosition();
      })
      .catch(() => {
        toast.error("Nhập excel thất bại");
      });
  };
  resetStore = () => {
    this.searchPosition = new SearchObject();
    this.pagePosition = null;
    this.selectedPosition = null;
    this.openFormCreateOrEdit = false;
    this.openConfirmDeletePosition = false;
  };
}
